import React, { useEffect, useMemo, useState } from 'react'
import Grid from '@mui/material/Grid'
import CompanyHistoryList from './history/CompanyHistoryList'
import { useLoaderData } from 'react-router'
import ConvertiblesApi from '../../../api/ConvertiblesApi'
import { useQuery } from '../../../hooks/useQuery'
import { TradesGraph } from './trades-graph'
import { CurrentTransactions } from './CurrentTransctions/CurrentTransactions'
import { SHARE_SELECT_ROUTING_PARAM } from './CompanyShare'
import { CompanyRecentPressReleases } from './CompanyRecentPressReleases'
import { useLogUserEvent } from '../../../hooks/useLogUserEvent'
import {
    CompanySingleItem,
    ConvertibleListItemByCompany,
    SplitOrBonusIssueData,
    USER_EVENT_TYPES,
} from '@finance-lab/utils/types'

const convertiblesApi = new ConvertiblesApi()

function CompanyDetailsView() {
    const [convertibles, setConvertibles] = useState<ConvertibleListItemByCompany[] | null>(null)
    const query = useQuery()
    const company: CompanySingleItem = useLoaderData()

    useLogUserEvent(USER_EVENT_TYPES.SHOW_COMPANY, { id: company.id })

    const selectedShare =
        company?.shares.find((i) => i.id === query.get(SHARE_SELECT_ROUTING_PARAM)) || company?.shares?.[0]

    useEffect(() => {
        if (!company) return

        const fetchData = async () => {
            try {
                const fetchedConvertibles = await convertiblesApi.findByCompanyId(company.id)

                setConvertibles(fetchedConvertibles)
            } catch (e) {
                console.error(e)
            }
        }
        void fetchData()
    }, [company])

    const shareCapitalChanges = useMemo(
        () =>
            [
                ...(selectedShare.splits?.map((s) => ({ ...s, type: 'split' })) || []),
                ...(selectedShare.bonusIssues?.map((s) => ({ ...s, type: 'bonus issue' })) || []),
            ] as SplitOrBonusIssueData[],
        [selectedShare.bonusIssues, selectedShare.splits],
    )

    return (
        <Grid container spacing={6}>
            <Grid size={{ xs: 12 }}>
                {selectedShare && (
                    <TradesGraph
                        companyId={company.id}
                        instrumentId={selectedShare.instrumentId}
                        instrumentName={selectedShare.symbol}
                        shareCapitalChanges={shareCapitalChanges}
                    />
                )}
            </Grid>
            <CompanyRecentPressReleases companyId={company.id} />
            <Grid size={{ xs: 12, md: 12 }}>
                <CurrentTransactions convertibles={convertibles || []} />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
                <CompanyHistoryList convertibles={convertibles} />
            </Grid>
        </Grid>
    )
}

export default CompanyDetailsView
